export function formatPronouns(pronouns: string | null): string {
    if (!pronouns) return '';

    return pronouns.charAt(0).toUpperCase() + pronouns.slice(1);
}
